export const FormMixin = {
  data() {
    return {
      isSubmit: false
    };
  },
  methods: {
    resetFieldErrors(provider) {
      /*
        requestAnimationFrame(() => {
            this.$refs[provider].reset();
        });
      */
    },
    onSubmit() {
      this.isSubmit = true;
      this.$q.loading.show();
      this.processSubmit().finally(() => {
        this.isSubmit = false;
        this.$q.loading.hide();
      });
    }
  }
}
